import React from 'react';

export default function CheckmarkFilledIcon(props) {
  const { fill } = props;
  return (
    <svg
      data-testid="all-set-checkbox"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>checked</title>
      <defs>
        <path
          d="M5.77777778,10.2222222 C5.52651852,10.2222222 5.28474074,10.1226667 5.10696296,9.9437037 L0.277333333,5.3997037 C0.0995555556,5.22192593 0,4.98133333 0,4.72888889 C0,4.47644444 0.0995555556,4.23585185 0.277333333,4.05925926 L0.949333333,3.38844444 C1.13422222,3.20355556 1.376,3.11111111 1.61896296,3.11111111 C1.86192593,3.11111111 2.1037037,3.20355556 2.28977778,3.38844444 L5.77777778,6.66666667 L11.9324444,0.277333333 C12.1102222,0.0995555556 12.352,0 12.6032593,0 L12.6032593,0 C12.8545185,0 13.0962963,0.0995555556 13.2740741,0.277333333 L13.9448889,0.946962963 C14.3146667,1.31792593 14.3146667,1.91881481 13.9448889,2.28859259 L6.44859259,9.9437037 C6.27081481,10.1226667 6.02903704,10.2222222 5.77777778,10.2222222"
          id="path-1"
        />
      </defs>
      <g
        id="selectors/radio/checked"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect id="Rectangle" x="0" y="0" width="32" height="32" />
        <g id="fill" fill={fill || '#3D57FF'}>
          <circle cx="16" cy="16" r="16" />
        </g>
        <g id="outline" stroke={fill || '#3D57FF'}>
          <circle cx="16" cy="16" r="15.5" />
        </g>
        <g id="tick" transform="translate(9.147496, 11.708089)">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use fill="#FFFFFF" xlinkHref="#path-1" />
        </g>
      </g>
    </svg>
  );
}
